<template>
  <div class="guidance" v-if="isFirstUse">
    <div class="start-page" v-show="showStartPage">
      <div class="username">
        <span>{{username}}</span>
        <div class="bottom-arrow"></div>
      </div>
      <div class="hello">
        <p>欢迎来到来画动画，开启你的动画创作之旅。</p>
        <p>几个小技巧，帮你快速get到动画创作~(*^▽^*)</p>
      </div>
    </div>

    <div class="guidance-swiper" v-show="showGuidanceSwiper">
      <el-carousel
        ref="carousel"
        indicator-position="outside"
        arrow="never"
        :autoplay="false"
        :interval="10000"
        trigger="click"
        height="535px"
        @change="changeIndex"
      >
        <el-carousel-item v-for="item in 4" :key="item"></el-carousel-item>
      </el-carousel>
      <div class="swiper-footer">
        <ul class="indicators">
          <li
            class="indicator"
            v-for="item in 4"
            @click="setActiveItem(item-1)"
            :class="(item-1) == activeIndex ? 'is-active' : ''"
          >
            <button class="indicator-btn"></button>
          </li>
        </ul>
        <span class="next-btn" @click="next" v-show="activeIndex !== 3">下一步</span>
        <span class="next-btn" @click="skip(false)" v-show="activeIndex === 3">立即开启</span>
        <span class="skip" @click="skip(true)">跳过</span>
      </div>
    </div>

    <div
      class="versionUpdate"
      v-if="judgeStep == 1 && this.UserMsg.versionUpdate && this.UserMsg.versionData.data.length"
    >
      <div class="imgBox" v-if="false">
        <el-carousel
          ref="newVersion"
          indicator-position="outside"
          arrow="always"
          :autoplay="false"
          :interval="10000"
          trigger="click"
          height="535px"
          @change="changeIndex"
        >
          <el-carousel-item
            v-for="(item, index) in this.UserMsg.versionData.data"
            :key="item.url+index"
          >
            <img :src="item.url" />
          </el-carousel-item>
        </el-carousel>
      </div>

      <div class="bar">
        <ul class="indicators" v-if="false">
          <li
            class="indicator"
            v-for="(item, index) in this.UserMsg.versionData.data"
            @click="setActiveItem(index, 1)"
            :class="(index) == activeIndex ? 'is-active' : ''"
          ></li>
        </ul>

        <div class="linkUrl" v-if="this.UserMsg.versionData.linkUrl">
          <a :href="this.UserMsg.versionData.linkUrl" target="_blank">查看详情</a>
        </div>
      </div>

      <div class="video_box">
          <!-- src="https://resources.laihua.com/video/cooperation.mp4" -->
        <video
          src="https://resources.laihua.com/2021-6-7/4bebdbbb-852d-48fe-b721-9c01457e1192.mp4"
          loop="loop"
          controls="controls"
          autoplay="autoplay"
          width="100%"
          height="100%"
        ></video>
      </div>
      <div class="closeBtn el-icon-close" @click="clickToClose()"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      isFirstUse: false,
      showStartPage: true,
      username: "王小二",
      showGuidanceSwiper: false,
      activeIndex: 0,
      isFirstAddScene: false,
      judgeStep: 0, // 判断操作步骤到了哪一步 1--新增功能循环，
    };
  },
  computed: {
    ...mapGetters(["UserMsg"]),
  },
  mounted() {
    // eve.on('windowLoading', (data) => {
    //   if(this.UserMsg.versionNumber >= 400 && this.UserMsg.versionNumber != this.UserMsg.versionTOOL){

    //     this.showStartPage = false;
    //     this.showGuidanceSwiper = false;
    //     this.$http.post('/api/user/info/guidance', {
    //       // guidance: '4.6.0'
    //       guidance: this.versionToolFS()
    //     });
    //   }else if( this.UserMsg.versionNumber <= 400 ){

    //     this.username = this.UserMsg.nickname || '来画君';
    //     this.showStartPage = this.isFirstUse = true;
    //     if (this.isFirstUse) {
    //       setTimeout(() => {
    //         this.showStartPage = false;
    //         this.showGuidanceSwiper = true;
    //         if ( this.UserMsg.guidance === '4.0.0' ) return;
    //         this.$http.post('/api/user/info/guidance', {
    //           // guidance: '4.6.0'
    //           guidance: this.versionToolFS()
    //         });
    //       }, 3000);
    //     }
    //   }
    // });

    this.$bus.on("touchGuidance_vue", (flag) => {
      console.log(`Turbo ~ this.$bus.on ~ flag`, flag)
      if (flag === false) {
        this.isFirstUse = true;
        return;
      }
      if (this.UserMsg.versionUpdate) {
        this.judgeStep = 1;
        this.isFirstUse = true;
        this.showStartPage = false;
        this.showGuidanceSwiper = false;
      }
    });
  },
  methods: {
    changeIndex(index) {
      this.activeIndex = index;
    },
    setActiveItem(index, type) {
      switch (type) {
        case 1:
          if (this.UserMsg.versionUpdate) {
            this.$refs.newVersion.setActiveItem(index);
            this.activeType = index;
          }
          return;
          break;
      }
      if (this.UserMsg.versionNumber > 400) {
        if (this.UserMsg.versionUpdate) {
          this.$refs.newVersion.setActiveItem(index);
          this.activeType = index;
        }
      } else {
        if (!this.UserMsg.versionNumber || this.UserMsg.versionNumber <= 400) {
          this.$refs.carousel.setActiveItem(index);
          this.activeType = index;
        }
      }
    },
    next() {
      this.setActiveItem(this.activeIndex + 1);
    },
    skip(isSkip) {
      this.isFirstUse = this.showGuidanceSwiper = false;
      if (!isSkip) {
        // 立即开启
        // 从模板第一次进入编辑器
        if (window.location.href.indexOf("template") !== -1) {
          window.localStorage.setItem("used", "used");
          return;
        }
        this.$bus.emit("showGuidanceStyle");
        return;
      }
      // 跳过
      if (
        window.localStorage.getItem("used") ||
        this.UserMsg.guidance === "4.0.0"
      )
        return;
      window.localStorage.setItem("used", "used");
    },
    versionToolFS() {
      var strt = this.UserMsg.versionTOOL + "",
        version = "";
      for (let index = 0, jk = strt.length; index < jk; index++) {
        if (index !== strt.length - 1) {
          version = version + strt[index] + ".";
        } else {
          version = version + strt[index];
        }
      }
      return version;
    },
    clickToClose () {
      this.isFirstUse = false;
      this.$bus.emit('Guidance.closed');
    }
  },
};
</script>

<style lang="scss">
.guidance {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  .start-page {
    // 开始页面
    position: relative;
    width: 951px;
    height: 612px;
    background: url("../../static/img/guide-home-page.jpg") no-repeat center;
    .username {
      position: absolute;
      top: 154px;
      left: 195px;
      width: 214px;
      height: 50px;
      border-radius: 25px;
      background-color: #fff;
      font-size: 18px;
      color: #5778fb;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        display: block;
        width: 136px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .bottom-arrow {
        position: absolute;
        display: block;
        width: 0;
        height: 0;
        border-color: transparent;
        border-style: solid;
        bottom: -11px;
        right: 45px;
        border-width: 11px;
        border-bottom-width: 0;
        border-top-color: #fff;
        &::after {
          position: absolute;
          display: block;
          width: 0;
          height: 0;
          border-color: transparent;
          border-style: solid;
          right: -11px;
          bottom: -11px;
          margin-left: -5px;
          border-bottom-width: 0;
          border-top-color: #fff;
          border-width: 11px;
        }
      }
    }
    .hello {
      position: absolute;
      top: 279px;
      left: 309px;
      p {
        font-size: 16px;
        color: #fff;
        text-align: left;
        margin-bottom: 14px;
      }
    }
  }
  .guidance-swiper {
    position: relative;
    width: 951px;
    height: 612px;
    background-color: #fff;
    ul.el-carousel__indicators {
      display: none;
    }
    .el-carousel__item h3 {
      color: #475669;
      font-size: 14px;
      opacity: 0.75;
      line-height: 150px;
      margin: 0;
    }

    .el-carousel__item:nth-child(1) {
      background: url("../../static/img/guide-one.gif") no-repeat center;
      background-size: contain;
    }
    .el-carousel__item:nth-child(2) {
      background: url("../../static/img/guide-two.gif") no-repeat center;
      background-size: contain;
    }
    .el-carousel__item:nth-child(3) {
      background: url("../../static/img/guide-three.gif") no-repeat center;
      background-size: contain;
    }
    .el-carousel__item:nth-child(4) {
      background: url("../../static/img/guide-four.gif") no-repeat center;
      background-size: contain;
    }
    .swiper-footer {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: 77px;
      background-color: #fff;
      .indicators {
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        width: 151px;
        list-style: none;
        margin-left: 323px;
        .indicator {
          display: inline-block;
          background-color: transparent;
          cursor: pointer;
          .indicator-btn {
            display: block;
            width: 16px;
            height: 16px;
            background-color: #d0d9ff;
            border-radius: 50%;
            border: none;
            outline: 0;
            padding: 0;
            margin: 0;
            cursor: pointer;
            transition: 0.3s;
          }
        }
        .is-active {
          .indicator-btn {
            background-color: #5778fb;
          }
        }
      }
      .next-btn {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 120px;
        height: 40px;
        color: #fff;
        background-color: #5778fb;
        border-radius: 8px;
        cursor: pointer;
        margin-left: 57px;
      }
      .skip {
        text-decoration: underline;
        color: #5778fb;
        cursor: pointer;
        margin-left: 248px;
      }
    }
  }
  .versionUpdate {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    width: 951px;
    height: 612px;
    background-color: #ffffff;

    ul.el-carousel__indicators {
      display: none;
    }

    .imgBox {
      position: absolute;
      top: 0;
      left: 0;
      width: 951px;
      height: 535px;
      overflow: hidden;
      background-color: #5778fb;

      .el-carousel__arrow {
        font-size: 18px;
        color: #5778fb;
        width: 50px;
        height: 50px;
        background-color: #ffffff;
        box-shadow: 0px 0px 6px 0px rgba(32, 32, 32, 0.24);
      }
    }
    .bar {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 951px;
      height: 77px;
      overflow: hidden;

      .indicators {
        position: absolute;
        top: 33px;
        left: 0;
        right: 0;
        margin: auto;
        width: 600px;
        height: 16px;
        display: flex;
        justify-content: center;
        overflow: hidden;

        .indicator {
          width: 16px;
          height: 16px;
          border-radius: 16px;
          background-color: #d0d9ff;
          cursor: pointer;
          margin-right: 45px;

          &:hover {
            background-color: #5778fb;
          }
        }
        .is-active {
          background-color: #5778fb;
        }
        .indicator:last-child {
          margin-right: 0px;
        }
      }

      .linkUrl {
        position: absolute;
        top: 33px;
        right: 24px;
        a {
          font-family: MicrosoftYaHei;
          text-decoration: underline;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #5778fb;
        }
      }
    }
    .closeBtn {
      position: absolute;
      top: 0;
      right: -40px;
      width: 40px;
      height: 40px;
      font-size: 24px;
      line-height: 40px;
      cursor: pointer;
      color: #fff;
      background-color: rgba(255, 255, 255, 0.1);
      &:hover {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }

    .video_box {
      width: 100%;
      height: 100%;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Guidance.vue